import { render } from "./ProductEditor.vue?vue&type=template&id=bd2082b2&scoped=true"
import script from "./ProductEditor.vue?vue&type=script&lang=js"
export * from "./ProductEditor.vue?vue&type=script&lang=js"

import "./ProductEditor.vue?vue&type=style&index=0&id=bd2082b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2082b2"]])

export default __exports__